// extracted by mini-css-extract-plugin
export var hideEditor = "_l5-2";
export var infoIcon = "_l5-3";
export var label = "_l5-1";
export var labelContainer = "_l5-0";
export var readonlyText = "_l5-4";